import { baseUrl } from "./baseUrl";

export function buildUrl(url) {
  return `${baseUrl}${url}`;
}
